import React from 'react';
import {useTranslation} from 'react-i18next';
import {Form, Formik} from 'formik';
import FilterBySixMonths from '../Components/FilterBySixMonths';
import MonthRangeFilter from './MonthRangeFilter';
import LightGreenButton from '../../Buttons/LightGreenButton';
import GreenButton from '../../Buttons/GreenButton';
import {RequestOrdersDataType} from '../../../types/TypesUserOrders';
import {useMonthRangeFilter} from '../../../hooks/useMonthRangeFilter';

type Props = {
	active: boolean;
	setFilters: any;
};

const OrdersActivitiesFilter: React.FC<Props> = ({active, setFilters}) => {
	const {t} = useTranslation();
	const monthRangeFilter = useMonthRangeFilter();
	
	const initialValues: RequestOrdersDataType & {month?: string} = {
		offset: 0,
		month: monthRangeFilter.month,
	};
	
	const handleSubmit = (values: RequestOrdersDataType & {month?: string}) => {
		// Используем даты из хука
		setFilters({
			filter_active: 1,
			offset: 0,
			from_date: monthRangeFilter.fromDate,
			to_date: monthRangeFilter.toDate,
		});
	};
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<Formik 
					initialValues={initialValues} 
					onSubmit={handleSubmit}
					enableReinitialize
				>
					{({handleSubmit, resetForm, values, setFieldValue}) => {
						// Синхронизируем месяц из формы с хуком
						React.useEffect(() => {
							if (values.month && values.month !== monthRangeFilter.month) {
								monthRangeFilter.setMonth(values.month);
							}
						}, [values.month]);
						
						// Обработка изменения месяца - обновляем количество дней и сбрасываем ползунки
						const handleMonthChange = React.useCallback(async (month: string) => {
							monthRangeFilter.setMonth(month);
							await setFieldValue('month', month);
						}, [setFieldValue, monthRangeFilter]);
						
						// Обертка для setFieldValue, которая обрабатывает изменение месяца
						const wrappedSetFieldValue: typeof setFieldValue = async (field, value, shouldValidate) => {
							if (field === 'month') {
								await handleMonthChange(value);
							} else {
								return setFieldValue(field, value, shouldValidate);
							}
						};
						
						return (
							<Form onSubmit={handleSubmit}>
								<FilterBySixMonths 
									setFieldValue={wrappedSetFieldValue}
								/>
								<div className="form-filter__item">
									<div className="item-select2__label">{t('Діапазон днів')}</div>
									<MonthRangeFilter
										sliderValue={monthRangeFilter.adaptedRangeValue}
										displayValue={monthRangeFilter.displayRangeValue}
										onChange={monthRangeFilter.handleRangeChange}
										maxValue={monthRangeFilter.daysInMonth - 1}
										maxDisplayValue={monthRangeFilter.daysInMonth}
									/>
								</div>
								<div className="item-filter__buttons">
									<LightGreenButton text={t('застосувати')} type={'submit'} />
									<GreenButton
										text={t('скасувати фільтр')}
										type={'button'}
										onClick={() => {
											resetForm();
											monthRangeFilter.reset();
											setFieldValue('month', monthRangeFilter.month);
											setFilters &&
												setFilters({
													filter_active: 0,
													offset: 0,
													from_date: monthRangeFilter.fromDate,
													to_date: monthRangeFilter.toDate,
												});
										}}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default OrdersActivitiesFilter;
